<template>
  <div class="Pay">
    <div class="page-title">{{$t('title.pay')}}</div>
    <div class="row-splitter">
      <ATable
        ref="table_customer"
        max-height="417"
        v-loading="loading_contract"
        :data="tableDataContract"
        :placeholder="searchPlaceHolder"
        :summaryTitleColumnIndex="2"
        :summaryFields="summaryFields"
        :search_field="search_field"
        :page-size="15"
        show-summary
        hide-button-insert
        hide-pagination
        highlight-current-row
        border
        @current-change="handleCurrentChange"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period"
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.indexw"
        />
        <el-table-column
          prop="name"
          label="거래처"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="location"
          label="사업장"
          min-width="200"
          show-overflow-tooltip
        />
        <el-table-column
          prop="sum_income"
          label="매입액"
          width="100"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="sum_paid"
          label="결제금"
          width="100"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="balance"
          label="미결제"
          width="100"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="modified_at"
          label="변경일" 
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>

    <div class="row-splitter">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input 
            placeholder="거래처" 
            v-model="customer.customer_name" 
            readonly
          >
            <template slot="prepend">거래처</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input 
            placeholder="사업장" 
            v-model="customer.location" 
            readonly
          >
            <template slot="prepend">사업장</template>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input 
            placeholder="미결제" 
            class="right" 
            :value="util.addComma(customer.balance)" 
            readonly
          >
            <template slot="prepend">미결제</template>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <div class="row-splitter">
      <div class="list-title">
        <h3>결제금 리스트</h3>
      </div>
      <ATable
        ref="table_sale"
        max-height="250"
        class="no-pointer"
        v-loading="loading_pay"
        :data="tableDataSale"
        hide-top-panel
        hide-button-insert
        hide-pagination
        border
      >
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexSale"
          :width="$width.index"
        />
        <el-table-column
          prop="pay_way_flag"
          label="결제 방법"
          :formatter="formatPayWay"
        />
        <el-table-column
          prop="pay_date"
          label="결제 일자"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="current_price"
          label="잔액"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="결제액"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="discount_price"
          label="할인액"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="합계"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        >
          <template slot-scope="scope">{{scope.row.price + scope.row.discount_price | number}}</template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { account_form } from "@/common/mixins/account_form";

export default {
  name: "Invoice",
  mixins: [account_form],
  data() {
    return {
      title:  this.$t("title.pay"),
      period: {},
      searchPlaceHolder: "거래처, 사업장",
      search_field: ["name", "location"],
      summaryFields: ['sum_income', 'sum_paid', 'balance'],
      search_fieldSale: ["name", "location"],
      searchWord: null,
      fixedSearchWord: "",
      pageSize: 10,
      currentPageContract: 1,
      currentPageSale: 1,
      loading_contract: false,
      items_customer: [],
      contractSelection: [],
      customer: {},
      loading_pay: false,
      items_pay: [],
      saleSelection: [],      
      search_period: {value: '0d'},
    };
  },
  computed: {
    ...mapGetters(["table_customer"]),
    pay_way_flag_options: function() {
      return this.system.options.pay_way_flag;
    },

    /* 매입 */
    filterDataContract: function() {
      let items = this.items_customer;
      items = this.util.filterMultiFields(
        items,
        this.search_field,
        this.fixedSearchWord
      );
      return items;
    },
    recordCountContract() {
      return this.filterDataContract.length;
    },
    tableDataContract() {
      return this.filterDataContract;
    },

    /* 결제 */
    filterDataSale: function() {
      return this.items_pay;
    },
    recordCountSale() {
      return this.filterDataSale.length;
    },
    tableDataSale() {
      // return this.filterDataSale.slice(((this.currentPageSale - 1) * this.pageSize), (this.pageSize * this.currentPageSale))
      return this.filterDataSale;
    }
  },
  mounted() {
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.loadData();
    },
    handleClickFilter() {
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.fixedSearchWord = this.searchWord;
      this.selectFirstCustomer();
    },
    selectFirstCustomer(id) {
      this.$nextTick(() => {
        let table = this.$refs.table_customer;
        let data = table.data;
        if (data) {
          let row = data.find(item => item.id === id);
          setTimeout(() => {
            table.setCurrentRow(id ? row : data[0]);
          }, 100);
        }
      });
    },
    loadData(id) {
      this.loading_contract = true;
      this.api.listPaySum(this.period).then(res => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_customer = this.organizeData(res.data);
        this.selectFirstCustomer(id);
      });
    },
    organizeData(items) {
      items.forEach(item => {
        let c = this.table_customer.find(c => c.id === item.id);
        if (!c) { return true; }
        item.name = c.name;
        item.location = c.location;
      })
      return items.sort(this.sortItems);
    },
    sortItems(a, b) {      
      if (a.modified_at !== b.modified_at) {
        return a.modified_at > b.modified_at ? -1 : 1;
      } else {        
        return a.name > b.name ? 1 : -1;
      }
    },    
    loadPay() {
      let customer_id = this.customer.id;

      if (!customer_id) {
        this.items_pay = [];
        return;
      }

      this.loading_pay = true;
      this.api.listPay(customer_id, this.period).then(res => {
        this.loading_pay = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.title, res.message);
          return;
        }

        this.items_pay = res.data;
      });
    },
    formatPayWay(row, cell, cellValue) {
      if( cellValue == '2' ) {
        return this.getBankAccountName(row.account_id);
      }

      let pay_way = this.pay_way_flag_options.find(item => {
        return item.value === cellValue;
      });
      return pay_way ? pay_way.label : null;
    },
    handleIndex(index) {
      return this.$refs.table_customer.indexResolver(index);
    },
    handleIndexSale(index) {
      // return this.recordCountSale - ((this.currentPageSale - 1) * this.pageSize) - index;
      return this.recordCountSale - index;
    },
    handleCurrentChange(currentRow/*, oldCurrentRow*/) {      
      this.customer = currentRow ? currentRow[0] : {};
      this.customer.customer_id = this.customer.id;
      this.customer.customer_name = this.customer.name;
      this.loadPay();
    },
    handleCompleted(action, message) {
      this.dialogVisible = false;
      this.form_data = undefined;

      let id = this.customer.id;

      switch (action) {
        case "create":
        case "delete":
          this.loadData(id);

          this.currentPageSale = 1;
          this.loadPay();
          break;
        case "update":
          this.loadData(id);
          this.loadPay();
          break;
      }
      if (!message) { return; }
      this.$notify(message);
    },
  }
};
</script>
<style lang="scss">
.search-keyword {
  width: 300px;
  margin-right: 20px;
}

.search-status {
  width: 200px;
  margin-right: 20px;
}
</style>
